import { Input } from 'antd';
import React, { useEffect, useRef, useState } from 'react'

const OtpComponent = ({ handleOtpDone }) => {
    const [otpInputs, setOtpInputs] = useState(['', '', '', '', '', ''])
    const otpInputRefs = useRef([
        React.createRef(),
        React.createRef(),
        React.createRef(),
        React.createRef(),
        React.createRef(),
        React.createRef(),
    ]);

    const handleOtpInputChange = (value, index) => {
        const updatedInputs = [...otpInputs]
        updatedInputs[index] = value
        setOtpInputs(updatedInputs)
    
        // Automatically focus on the next input if a number is entered
        if (value && index < otpInputs.length - 1) {
          otpInputRefs.current[index + 1].current.focus()
        }
    
        // Check if the current input is the last one and all inputs are filled
        // if (index === otpInputs.length - 1 && updatedInputs.every(input => input !== "")) {
        //     // Call your function here
        //     handleOtpDone();
        // }
    }

    useEffect(() => {
        if (otpInputs.join('').length === 6) {
          handleOtpDone(otpInputs.join(''))
        }
    }, [otpInputs]);

    const handleKeyPress = (e) => {
        const regex = /^[0-9]*$/
        const isValid = regex.test(e.key)
        if (!isValid) {
          e.preventDefault()
        }
    }

  return (
    <div className='w-full px-10 flex justify-between mt-6'>
      {otpInputs.map((inputValue, index) => (
            <Input
                key={index}
                size="large"
                style={{
                    width: 50,
                    border: '2px solid #E4342D',
                    marginRight: 8,
                    textAlign: 'center',
                    color: '#E4342D',
                    fontWeight: 'bold',
                    fontSize: 20,
                }}
                autoFocus={index === 0} // Autofocus only on the first input
                value={inputValue}
                placeholder="0"
                onKeyPress={handleKeyPress}
                maxLength={1} // Limit each input to a single character
                onChange={(e) => handleOtpInputChange(e.target.value, index)}
                ref={otpInputRefs.current[index]}
            />
        ))}
    </div>
  )
}

export default OtpComponent
